import { Checkbox, Icon } from 'semantic-ui-react';
import { useShare } from '../../context/ShareContext';
import './ClosetCard.css';

const ClosetCard = ({ closet, onClick, onEdit, isBulkMode = false, isSelected = false, isDefault = false, isHorizontal = false }) => {
  const { name, previewImages = [], itemCount = 0 } = closet;
  const { openShare } = useShare();

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit?.(closet);
  };

  const handleShareClick = (e) => {
    e.stopPropagation();
    openShare({
      sourceType: 'closet',
      closetId: closet.id,
      title: name,
      itemCount,
      previewImages
    });
  };

  return (
    <div
      className={`closet-card ${isBulkMode ? 'bulk-mode' : ''} ${isSelected ? 'selected' : ''} ${isDefault && isBulkMode ? 'disabled' : ''} ${isHorizontal ? 'horizontal-mode' : ''}`}
      onClick={onClick}
    >
      {/* Bulk selection checkbox */}
      {isBulkMode && !isDefault && (
        <div className="closet-checkbox-wrapper">
          <Checkbox checked={isSelected} onChange={() => { }} />
        </div>
      )}
      <div
        className="closet-preview-row"
        data-count={previewImages.slice(0, 4).length}
      >
        {previewImages.length > 0 ? (
          previewImages.slice(0, 4).map((url, index) => (
            <div key={index} className="preview-cell">
              <img src={url} alt="" className="preview-image" />
            </div>
          ))
        ) : (
          <div className="empty-preview">
            <span>{itemCount} items</span>
          </div>
        )}
      </div>
      <div className="closet-name-bar">
        <span className="closet-name">{name}</span>
        {!isBulkMode && (
          <div className="closet-card-actions">
            <Icon
              name="share alternate"
              className="closet-share-icon"
              title={`Share ${name}`}
              onClick={handleShareClick}
            />
            <Icon
              name="pencil"
              className="closet-edit-icon"
              onClick={handleEditClick}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClosetCard;
